import { render, staticRenderFns } from "./AddnewJudgment.vue?vue&type=template&id=40436a34&scoped=true"
import script from "./AddnewJudgment.vue?vue&type=script&lang=js"
export * from "./AddnewJudgment.vue?vue&type=script&lang=js"
import style0 from "./AddnewJudgment.vue?vue&type=style&index=0&id=40436a34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40436a34",
  null
  
)

export default component.exports